<template>
  <div class="tag-privacy-popup">
    <popper
      ref="popper"
      :options="{
        placement: 'top',
        modifiers: { offset: { offset: '0,10px' } }
      }"
      class="popper-wrap"
      trigger="click">
      <div class="popper">
        <div class="popper-content">
          <header>
            <h3>{{ $t('profile.tags.privacyPopup.title') }}</h3>
            <span class="icon"><i :class="privacyClass" /></span>
          </header>
          <span class="message" v-html="message" />
          <tags-input
            v-slot="{ tags }"
            :create-tag="createTag"
            :placeholder="placeholder"
            :query="queryTags"
            :value="requireTags"
            @input="updateTags">
            <tag-item
              v-for="(badgeTag, i) in tags"
              :key="i"
              :tag="badgeTag"
              @remove="removeTag" />
          </tags-input>
          <span class="desc">{{ desc }}</span>
          <button class="save" @click="close">
            <i class="ti-check" />
          </button>
        </div>
      </div>

      <div slot="reference" class="popper-ref">
        <span class="tag-title">{{ tag.title }}</span>
        <span class="micro transparent"><i :class="privacyClass" /></span>
      </div>
    </popper>
  </div>
</template>

<script>
import TagsInput from './TagsInput'
import TagItem from './TagItem'
import Popper from 'vue-popperjs'
import Tags from '../../../lib/tags'
import removeProp from '../../../lib/remove-prop'

export default {
  name: 'TagPrivacyPopup',
  components: { Popper, TagsInput, TagItem },
  props: {
    tag: {
      type: Object,
      required: true
    },
    tagType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      requireTags: []
    }
  },

  computed: {
    message () {
      return this.requireTags.length
        ? this.$t('profile.tags.privacyPopup.message.private').replace('%%interest%%', `<b>${this.tag.title}</b>`)
        : this.$t('profile.tags.privacyPopup.message.public').replace('%%interest%%', `<b>${this.tag.title}</b>`)
    },

    desc () {
      return this.requireTags.length
        ? this.$t('profile.tags.privacyPopup.desc.private')
        : this.$t('profile.tags.privacyPopup.desc.public')
    },

    placeholder () {
      return this.requireTags.length
        ? this.$t('profile.tags.privacyPopup.placeholder.private')
        : this.$t('profile.tags.privacyPopup.placeholder.public')
    },

    privacyClass () {
      const length = this.requireTags.length
      if (length === 0) {
        return 'ti-eye'
      }
      if (length === 1) {
        return 'ti-unlock'
      }
      return 'ti-lock'
    }
  },

  watch: {
    value () {
      this.fromValue()
    }
  },

  created () {
    this.fromValue()
  },

  methods: {
    fromValue () {
      const tags = JSON.parse(JSON.stringify(((this.tag || {}).privacy || {}).requireTags || {}))
      this.requireTags = Object.entries(tags).reduce((result, [key, tag]) => [...result, {
        id: key,
        title: tag.title
      }], [])
    },
    queryTags (value) {
      // TODO query tags in this order: 1. the tag's title; 2. tags of the same type; 3. tags with any type; 4 tags without type
      return Tags.query(value)
    },
    createTag (title) {
      if (title) {
        return Tags.createTag(title, this.tagType)
      }
      return null
    },
    updateTags (tags) {
      this.requireTags = tags
    },
    removeTag (tag) {
      this.requireTags = Tags.removeTag(this.requireTags, tag)
    },

    close () {
      if (this.$refs.popper) {
        this.$refs.popper.doClose()
      }
      this.$emit('input', {
        ...JSON.parse(JSON.stringify(this.tag)),
        privacy: {
          requireTags: JSON.parse(JSON.stringify(this.requireTags)).reduce((result, tag) => ({
            ...result,
            [tag.id]: removeProp(tag, 'id')
          }), {})
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../../../assets/styles/vars";

  .tag-privacy-popup {

    header {
      margin-bottom: $basic-padding;

      h3 {
        margin: 0;
      }

      .icon {
        font-size: 150%;
      }
    }

    .message {
      b {
        padding: 0.1rem 0.3rem;
        background: rgba(0, 0, 0, 0.05);
        /*font-weight: 600;*/
        font-style: italic;
        border-radius: $tag-corner-radius;
      }
    }
    .tags-input-root {
      margin: 0 !important;
    }
    .tags-input {
      margin: $basic-padding 0 !important;

      .tag {
        background: #616161;

        .tag-title {
          padding-left: $basic-padding;
        }
      }

      input {
        background: rgba(0, 0, 0, 0.05);
        border-color: rgba(255, 255, 255, 0.5);
        color: #fff;

        &:focus {
          background: rgba(0, 0, 0, 0.15);
          border-color: rgba(255, 255, 255, 0.8);
        }

        &::placeholder {
          color: #404040;
        }
      }
    }

    button.save {
      background: #616161;
      box-shadow: none;
      margin: $basic-padding auto 0;
      height: $basic-size;

      color: #fff;
    }

    .tag-handle {
      display: none;
    }
  }
</style>
